import { FC } from 'react'
import { DisplayCard } from '@/ui/components/displayCard'
import { ActionPlanWrapper } from './ActionPlanCard.styles'
import { ActionPlan } from '@/ui/routes/summary/components/ActionPlan'
import { useActionPlan } from '../ActionPlan/useActionPlan'

const ActionPlanCard: FC = () => {
    const { messages, handleAction } = useActionPlan()

    if (!messages.length) {
        return null
    }

    return (
        <ActionPlanWrapper>
            <DisplayCard name="Action Plan">
                <ActionPlan messages={messages} handleAction={handleAction} />
            </DisplayCard>
        </ActionPlanWrapper>
    )
}

export default ActionPlanCard
